/* eslint-disable */
import React from 'react'
import ReactDOM from 'react-dom'

/** The table of tasks */
export function ResultsViewer(props) {
  return (
    <div className="question-ee-atlas">
      {props.content.tasks.map((task, taskidx) => (
        <TaskCard key={'task_' + taskidx} task={task} taskidx={taskidx} />
      ))}
    </div>
  )
}

function TaskCard(props) {
  if (props.task.rules.length === 0) {
    // A task's rules may have been deleted by a setting file
    return null
  } else {
    let points_earned_text = roundToPrecision(props.task.pointsEarned, 2)
    if (props.task.pointsPending > 0) {
      points_earned_text = '?'
    }
    return (
      <div className="task-card">
        <div
          className={
            'task-card-header ' +
            (props.task.pointsEarned === props.task.points
              ? 'correct'
              : props.task.pointsEarned === 0
              ? 'incorrect'
              : 'partial')
          }
        >
          <div className="task-number">Task {props.taskidx + 1}</div>
          <div className="task-points">
            {points_earned_text}/{props.task.points} points
          </div>
        </div>
        <div className="task-card-text">
          <div dangerouslySetInnerHTML={{ __html: props.task.text }} />
          <div>
            <TaskDeductions
              key={'deductions_' + props.task.id}
              task={props.task}
            />
            <NonDeductionsFeedback
              key={'feedback_' + props.task.id}
              task={props.task}
            />
          </div>
        </div>
      </div>
    )
  }
}

function TaskDeductions(props) {
  if (props.task.forSale === 'purchased') {
    /** The message that indicates that a task was purchased */
    return (
      <ul className="m-0 pl-0 list-plain badge-warning">
        No points are awarded here because the sytem automatically completed
        this task at the user's request.
      </ul>
    )
  } else if (props.task.pointsPending > 0) {
    /** The message that indicates that a task did not grade */
    return (
      <ul className="m-0 pl-0 list-plain badge-warning">
        The system was unable to grade this task on your computer. It has been
        submitted for evaluation.
      </ul>
    )
  } else {
    /** The deductions taken on a task */
    return (
      <ul className="m-0 pl-0 list-plain text-danger">
        {props.task.rules.map(rule => {
          if (rule.status !== 'feedback') {
            if (rule.pointsLost > 0) {
              let message = rule.message
              if (rule.feedback) {
                message += ' ' + rule.feedback
              }
              return (
                <li key={rule.id} className="d-flex">
                  <div className="flex-grow-0 flex-shrink-0 pr-1">
                    [-{rule.pointsLost}]
                  </div>
                  <div
                    className="flex-grow-1"
                    dangerouslySetInnerHTML={{ __html: message }}
                  />
                </li>
              )
            } else {
              return null
            }
          }
          return null
        })}
      </ul>
    )
  }
}

function NonDeductionsFeedback(props) {
  // check to see if there is is non-deduction feedback
  let positive_feedback = [
    'Outstanding',
    'Great work',
    'Excellent',
    'Superb',
    'Super',
    'Nice Job',
    'Fantastic',
    'Fabulous',
    'Awesome',
    'Marvelous',
    'Admirable Performance',
    'Well done',
    'Splendid',
    'Impressive',
    'Brilliant',
    'Magnificent',
    'Oh, you are good',
    'Good show',
  ]
  let fb_count = 0
  let points_lost = 0
  for (const rule of props.task.rules) {
    points_lost += rule.pointsLost
    if (rule.status === 'feedback') fb_count++
  }
  if (fb_count === 0) {
    if (points_lost === 0) {
      return (
        <div className="positive-feedback">
          {
            positive_feedback[
              Math.floor(Math.random() * positive_feedback.length)
            ]
          }
          ! You earned full credit for this task.
        </div>
      )
    } else return null
  }

  return (
    <ul className="m-0 pl-0 list-plain text-danger">
      <div className="feedback-header">
        The following feedback is for informational purposes only; no points are
        deducted.
      </div>
      {props.task.rules.map(rule => {
        if (rule.status === 'feedback') {
          //rule is feedback only, no point deduction
          let message = rule.message
          if (rule.feedback) {
            message += ' ' + rule.feedback
          }

          return (
            <li key={rule.id} className="d-flex">
              <div
                className="flex-grow-1 text-info"
                dangerouslySetInnerHTML={{ __html: message }}
              />
            </li>
          )
        }
        return null
      })}
    </ul>
  )
}

export function roundToPrecision(number_to_round, decimal_places) {
  return (
    Math.round(number_to_round * 10 ** decimal_places) / 10 ** decimal_places
  )
}

export const startAtlasResults = (div_id, content) => {
  ReactDOM.render(
    <ResultsViewer content={content} />,
    document.getElementById(div_id)
  )
}
